'use client';

import { TabPanel, TabView } from 'primereact/tabview';
import Banner from '../components/Banner';
import { getTab, setTab } from '../engine/people.library';
import ListPeopleScreen from './ListPeopleScreen';
import './people.styles.css';
import GroupTable from '../components/group/GroupTable';
import { TabHelper } from '@/common/TabHelper';

const PeopleScreen = () => {
	const currentTab = getTab();

	return (
		<div>
			<h1 className="text-5xl font-semibold">People</h1>
			<div className="mt-6">
				<Banner />
				<TabView
					activeIndex={currentTab}
					onTabChange={(e) => {
						setTab(e.index);
					}}
					className="mt-6"
					pt={TabHelper.TabViewProps}
				>
					<TabPanel
						pt={TabHelper.TabPanelProps}
						// biome-ignore lint/a11y/noNoninteractiveTabindex: TabPanel has no tabIndex prop, so putting it on its child instead.
						header={<div tabIndex={0}>People</div>}
					>
						<ListPeopleScreen />
					</TabPanel>
					<TabPanel
						pt={TabHelper.TabPanelProps}
						// biome-ignore lint/a11y/noNoninteractiveTabindex: TabPanel has no tabIndex prop, so putting it on its child instead.
						header={<div tabIndex={0}>Groups</div>}
					>
						<GroupTable />
					</TabPanel>
				</TabView>
			</div>
		</div>
	);
};

export default PeopleScreen;
